export const dialogPaperSx = {
  width: 602,
  maxWidth: 'calc(100vw - 32px)',
  borderRadius: '10px',
  overflow: 'hidden',
  bgcolor: '#FFFFFF',
  boxShadow: '0 8px 24px rgba(0, 0, 0, 0.20)'
};

export const dialogTitleSx = {
  minHeight: 64,
  px: 2,
  py: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  bgcolor: '#F8F9FB',
  borderBottom: '1px solid #DADADA'
};

export const dialogTitleTextSx = {
  fontSize: 20,
  fontWeight: 600,
  color: '#424242'
};

export const closeButtonSx = {
  color: '#424242',

  '&:hover': {
    bgcolor: '#EEEEEE'
  }
};

export const dialogContentSx = {
  px: 2,
  py: 2,
  mt:2
};

export const categoryRowSx = {
  display: 'flex',
  width: '100%',
  mb: 2
};

export const getCategorySelectSx = category => ({
  height: 56,
  flex: 1,
  bgcolor: '#FFFFFF',
  borderRadius: '4px 0 0 4px',
  color: category ? '#424242' : '#757575',

  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16
  },

  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#BDBDBD'
  },

  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#9E9E9E'
  },

  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#C79245',
    borderWidth: 1
  }
});

export const getCategoryActionButtonSx = isEdit => ({
  minWidth: 42,
  width: 42,
  height: 42,
  borderRadius: '0 4px 4px 0',
  boxShadow: 'none',
  bgcolor: isEdit ? '#EEEEEE' : '#C39751',
  color: isEdit ? '#616161' : '#FFFFFF',
  '& svg': {
    fontSize: 22
  },


  '&:hover': {
    bgcolor: isEdit ? '#E0E0E0' : '#B58237',
    boxShadow: 'none'
  }
});

export const newCategoryRowSx = {
  display: 'flex',
  width: '100%',
};

export const newCategoryFieldSx = {
  '& .MuiOutlinedInput-root': {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,

    '& fieldset': {
      borderColor: '#D9D9D9',
      borderWidth: '1px'
    },

    '&:hover fieldset': {
      borderColor: '#D9D9D9',
      borderWidth: '1px'
    },

    '&.Mui-focused fieldset': {
      borderColor: '#1976D2',
      borderWidth: '1px'
    }
  }
};
export const categorySaveButtonSx = {
  minWidth: 42,
  width: 42,
  height: 42,
  borderRadius: '0 4px 4px 0',
  bgcolor: '#C39751',
  boxShadow: 'none',
  '& svg': {
    fontSize: 22
  },


  '&:hover': {
    bgcolor: '#B58237',
    boxShadow: 'none'
  }
};

export const clinicalCategoryLabelSx = {
  ml: 0,

  '& .MuiCheckbox-root': {
    color: '#9E9E9E',

    '&.Mui-checked': {
      color: '#C79245'
    }
  }
};

export const clinicalCategoryTextSx = {
  fontSize: 13,
  color: '#616161'
};

export const documentTitleFieldSx = {
  width: '100%',
  mb: 2,

  '& .MuiOutlinedInput-root': {
    height: 56,
    borderRadius: '4px',

    '& fieldset': {
      borderColor: '#BDBDBD'
    },

    '&:hover fieldset': {
      borderColor: '#9E9E9E'
    },

    '&.Mui-focused fieldset': {
      borderColor: '#C79245',
      borderWidth: 1
    }
  },

  '& input': {
    fontSize: 15
  }
};

export const selectDocumentButtonSx = {
  height: 38,
  minWidth: 0,
  width: 'fit-content',
  px: 1.5,
  borderRadius: '4px',
  textTransform: 'uppercase',
  borderColor: '#E0E0E0',
  color: '#C39751',
  fontSize: 12,
  fontWeight: 600,
  bgcolor: '#FFFFFF',

  '& .MuiButton-startIcon': {
    color: '#C39751',
    marginRight: '6px',

    '& svg': {
      fontSize: 17
    }
  },

  '&:hover': {
    borderColor: '#C39751',
    bgcolor: '#FFF9F1'
  }
};

export const selectedFileTextSx = {
  mt: 1.25,
  fontSize: 12,
  color: '#757575'
};

export const dialogActionsSx = {
  minHeight: 84,
  px: 2,
  py: 1.5,
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 1.5,
  borderTop: '1px solid #E0E0E0',
  bgcolor: '#FFFFFF'
};

export const cancelButtonSx = {
  minWidth: 98,
  height: 42,
  px: 2,
  borderRadius: '4px',
  textTransform: 'uppercase',
  borderColor: '#D2D2D2',
  color: '#424242',
  fontSize: 13,
  fontWeight: 600,

  '&:hover': {
    borderColor: '#BDBDBD',
    bgcolor: '#FAFAFA'
  }
};

export const submitButtonSx = {
  minWidth: 96,
  height: 38,
  px: 2,
  borderRadius: '4px',
  textTransform: 'uppercase',
  bgcolor: '#C79245',
  fontSize: 13,
  fontWeight: 600,
  boxShadow: 'none',

  '&:hover': {
    bgcolor: '#B58237',
    boxShadow: 'none'
  },

  '&.Mui-disabled': {
    bgcolor: '#EEEEEE',
    color: '#BDBDBD'
  }
};

export const newCategoryControlSx = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  width: '100%',

  '& .MuiTextField-root': {
    flex: 1
  }
};

